

export class BasicCommandVO {
    constructor() {
    }

    public getCmdId(): string {
        return "";
    }
}

